export default function SubscriptionSkeleton() {
  return (
    <div className="flex flex-col gap-5 rounded-lg bg-white p-5">
      {/* Header skeleton */}
      <div className="flex flex-row items-center justify-between">
        <div className="space-y-2">
          <div className="h-5 w-32 animate-pulse rounded bg-gray-300" />
          <div className="h-3 w-64 animate-pulse rounded bg-gray-300" />
        </div>
        <div className="flex flex-row gap-4">
          <div className="h-8 w-24 animate-pulse rounded bg-gray-300" />
          <div className="h-8 w-20 animate-pulse rounded bg-gray-300" />
        </div>
      </div>

      {/* Header */}
      <div className="grid grid-cols-[2fr_1fr_1fr_1fr_1fr] gap-4 px-4 py-3">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="h-3 w-24 animate-pulse rounded bg-gray-300" />
        ))}
      </div>

      {/* Content skeleton */}
      <div className="grid grid-cols-[2fr_1fr_1fr_1fr_1fr] items-center gap-4 rounded-lg px-4 py-4">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="h-5 w-32 animate-pulse rounded bg-gray-300" />
        ))}
      </div>
    </div>
  );
}
